import {
  NotificationResponse,
  PaginatedResults,
  StandardResponse,
} from "@it-tc/legacy-api";
import emptySplitApi from "./emptySplitApi";

export type Notification = {
  id: number;
  read: boolean;
  message: string;
  eligibility: string;
};

const extendedApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<Notification[], undefined>({
      providesTags: ["Notification"],
      transformResponse: (
        response: StandardResponse<PaginatedResults<NotificationResponse[]>>,
      ) => response.response.results.map(mapToNotification),
      query: () => ({
        url: `${location.origin}/individualexamscheduler/services/notification/v1/notification.json`,
      }),
    }),
  }),
});

export const { useGetNotificationsQuery, useLazyGetNotificationsQuery } =
  extendedApi;

function mapToNotification(notification: NotificationResponse): Notification {
  return {
    id: notification.id,
    read: notification.isRead,
    message: notification.notificationMessage,
    eligibility: notification.eligibilityCode,
  };
}
